import React from 'react';
import { Group, Grid, Stack, Text, ColorSwatch } from '@mantine/core';
import { IconCheck, IconX } from '@tabler/icons-react';

function StaffServiceDetails({ employee, service, staffService }) {
  const canPerform = staffService !== undefined;

  return (
    <Stack position="apart" py="xs">
      <Group>
        {canPerform ? (
          <IconCheck size={16} color="green" />
        ) : (
          <IconX size={16} color="red" />
        )}
        <Text size="sm">
          {employee.first_name} {employee.last_name} - {employee.title}
        </Text>
      </Group>
      {canPerform && (
        <Grid align="center" pl="xl">
          <Grid.Col span={3}>
            <Stack gap={0}>
              <Text fw={600} size="sm">Duration</Text>
              <Text size="sm" c={staffService.duration_mins === service.default_duration_mins ? "dimmed" : "inherit"}>
                {staffService.duration_mins === service.default_duration_mins 
                  ? "Same as default" 
                  : `${staffService.duration_mins} minutes`}
              </Text>
            </Stack>
          </Grid.Col>
          <Grid.Col span={3}>
            <Stack gap={0}>
              <Text fw={600} size="sm">Price</Text>
              <Text 
                size="sm" 
                c={staffService.price === service.default_price && 
                   staffService.is_variable_price === service.default_is_variable_price ? "dimmed" : "inherit"}
              >
                {staffService.price === service.default_price && 
                 staffService.is_variable_price === service.default_is_variable_price ? (
                  "Same as default"
                ) : (
                  staffService.is_variable_price ? 
                    `$${staffService.price} and up` : 
                    `$${staffService.price}`
                )}
              </Text>
            </Stack>
          </Grid.Col>
          <Grid.Col span={3}>
            <Stack gap={0}>
              <Text fw={600} size="sm">Calendar Color</Text>
              <Group gap="xs">
                <ColorSwatch 
                  color={staffService.calendar_event_color || service.default_calendar_event_color}
                  size={16}
                  radius="sm"
                />
              </Group>
            </Stack>
          </Grid.Col>
          <Grid.Col span={3}>
            <Stack gap={0}>
              <Text fw={600} size="sm">Self-Service</Text>
              <Text 
                size="sm" 
                c={staffService.is_self_servicable === service.default_is_self_servicable ? "dimmed" : "inherit"}
              >
                {staffService.is_self_servicable === service.default_is_self_servicable ? (
                  "Same as default"
                ) : (
                  staffService.is_self_servicable ? "Yes" : "No"
                )}
              </Text>
            </Stack>
          </Grid.Col>
        </Grid>
      )}
    </Stack>
  );
}

export default StaffServiceDetails; 